<template>
  <div>
    <h1>Opps!</h1>
    <p>{{ message }}</p>
  </div>
</template>

<script>
  import {safeMeta} from "@/router/Meta";

  export default {
      data() {
          return {
              message: safeMeta(this.$route).error
          }
      }
  }
</script>
